import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Context as ReviewsContext } from "../../context/ReviewsContext";
import {
  makeStyles,
  Fade,
  Card,
  Typography,
  Box,
  AccordionSummary,
  AccordionDetails,
  Accordion,
  Grid,
  Chip,
} from "@material-ui/core";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import StarIcon from "@material-ui/icons/Star";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: theme.spacing(3),
    borderTopColor: theme.palette.secondary.light,
    borderTop: "12px solid",
  },
  row: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginTop: 8,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  commentBox:{
    maxWidth:"600px",
    border: "1px solid lightgray",
    borderRadius: 2,
    padding: 8,
    whiteSpace:"initial",
    wordWrap:"normal"
  }
}));

const Review = ({ history }) => {
  const { id } = useParams();
  const classes = useStyles();

  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const [review, setReview] = useState({
    name: "Product",
    units: 0,
    unitPrice: 0,
    description: "",
    url: "",
  });

  const {
    state: { reviews },
  } = useContext(ReviewsContext);

  useEffect(() => {
    const foundReview = reviews.find((r) => r.id === id);
    if (foundReview) {
      setReview(foundReview);
    } else {
      history.push("/reviews");
    }
  }, [id, reviews]);

  return (
    <Fade in>
      <Card className={classes.root}>
        <Typography variant="h6" component="h2">
          Detalle de Respuesta
        </Typography>
        <div className={classes.row}>
          <MailOutlineIcon />
          <Typography variant="body2" style={{ marginLeft: 12, wordBreak:"break-word" }}>
            {review.email}
          </Typography>
        </div>
        <Box mt={3}>
          <Typography variant="button">Preguntas:</Typography>
        </Box>
        <Accordion
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography className={classes.heading}>Servicio</Typography>
            <Typography className={classes.secondaryHeading}>
              {parseFloat(review.serviceScore).toFixed(2)}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid>
              <Grid item xs={12}>
                <div className={classes.row}>
                  <Typography>La atención del cochero es</Typography>
                  <Chip
                    icon={<StarIcon />}
                    color="secondary"
                    label={review.question2}
                    style={{ marginLeft: 10 }}
                  />
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.row}>
                  <Typography>
                    ¿Qué te parece la atención y tiempos de entrega del room
                    service?
                  </Typography>
                  <Chip
                    icon={<StarIcon />}
                    color="secondary"
                    label={review.question7}
                    style={{ marginLeft: 10 }}
                  />
                </div>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel2"}
          onChange={handleChange("panel2")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography className={classes.heading}>Calidad</Typography>
            <Typography className={classes.secondaryHeading}>
              {parseFloat(review.qualityScore).toFixed(2)}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid>
              <Grid item xs={12}>
                <div className={classes.row}>
                  <Typography>
                    ¿Qué te parece la imagen de nuestras instalaciones?
                  </Typography>
                  <Chip
                    icon={<StarIcon />}
                    color="secondary"
                    label={review.question1}
                    style={{ marginLeft: 10 }}
                  />
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.row}>
                  <Typography>La temperatura y presión del agua es</Typography>
                  <Chip
                    icon={<StarIcon />}
                    color="secondary"
                    label={review.question4}
                    style={{ marginLeft: 10 }}
                  />
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.row}>
                  <Typography>
                    ¿Consideras que las amenidades (jabón, shampoo, cepillo
                    dental, etc.) son suficientes?
                  </Typography>
                  <Chip
                    icon={<StarIcon />}
                    color="secondary"
                    label={review.question5}
                    style={{ marginLeft: 10 }}
                  />
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.row}>
                  <Typography>
                    ¿Cuál es tu opinión de la cortesía que te brinda el hotel?
                  </Typography>
                  <Chip
                    icon={<StarIcon />}
                    color="secondary"
                    label={review.question6}
                    style={{ marginLeft: 10 }}
                  />
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.row}>
                  <Typography>
                    ¿Cómo consideras la calidad de los alimentos adquiridos en
                    las instalaciones?
                  </Typography>
                  <Chip
                    icon={<StarIcon />}
                    color="secondary"
                    label={review.question8}
                    style={{ marginLeft: 10 }}
                  />
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.row}>
                  <Typography>
                    El contenido del menú, ¿Es de tu agrado?
                  </Typography>
                  <Chip
                    icon={<StarIcon />}
                    color="secondary"
                    label={review.question9}
                    style={{ marginLeft: 10 }}
                  />
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.row}>
                  <Typography>
                    ¿Cómo calificas la calidad del internet y canales de TV?
                  </Typography>
                  <Chip
                    icon={<StarIcon />}
                    color="secondary"
                    label={review.question11}
                    style={{ marginLeft: 10 }}
                  />
                </div>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel3"}
          onChange={handleChange("panel3")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography className={classes.heading}>Limpieza</Typography>
            <Typography className={classes.secondaryHeading}>
              {parseFloat(review.cleanlinessScore).toFixed(2)}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid>
              <Grid item xs={12}>
                <div className={classes.row}>
                  <Typography>
                    ¿Cómo consideras la limpieza y aroma de la habitación?
                  </Typography>
                  <Chip
                    icon={<StarIcon />}
                    color="secondary"
                    label={review.question3}
                    style={{ marginLeft: 10 }}
                  />
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.row}>
                  <Typography>
                    El estado y limpieza de los blancos, ¿Es adecuado?
                  </Typography>
                  <Chip
                    icon={<StarIcon />}
                    color="secondary"
                    label={review.question10}
                    style={{ marginLeft: 10 }}
                  />
                </div>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        <Box mt={3}>
          <Typography variant="button">Comentario</Typography>
          <div className={classes.commentBox}>{review.message}</div>
        </Box>
      </Card>
    </Fade>
  );
};
export default Review;
